import { createFileRoute } from '@tanstack/react-router'

import type { PerfilId } from '@/lib/visoes'

import { DetalheRegra } from '@/features/regras-processo/detalhe'

export const Route = createFileRoute('/$perfil/regras/$codigo')({
  component: Tela,
})

function Tela() {
  const { perfil, codigo } = Route.useParams()
  return <DetalheRegra codigo={codigo} perfil={perfil as PerfilId} />
}
